// extracted by mini-css-extract-plugin
export default {"profilePic":"uploadProfile_profilePic__QHQ17","profile":"uploadProfile_profile__wW1ct","icon":"uploadProfile_icon__zoVWO"};